"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a;
var revert_error_1 = require("../../revert_error");
// tslint:disable:max-classes-per-file
var InvalidFromAddressError = /** @class */ (function (_super) {
    __extends(InvalidFromAddressError, _super);
    function InvalidFromAddressError(from) {
        return _super.call(this, 'InvalidFromAddressError', 'InvalidFromAddressError(address from)', { from: from }) || this;
    }
    return InvalidFromAddressError;
}(revert_error_1.RevertError));
exports.InvalidFromAddressError = InvalidFromAddressError;
var AmountsLengthMustEqualOneError = /** @class */ (function (_super) {
    __extends(AmountsLengthMustEqualOneError, _super);
    function AmountsLengthMustEqualOneError(amountsLength) {
        return _super.call(this, 'AmountsLengthMustEqualOneError', 'AmountsLengthMustEqualOneError(uint256 amountsLength)', {
            amountsLength: amountsLength,
        }) || this;
    }
    return AmountsLengthMustEqualOneError;
}(revert_error_1.RevertError));
exports.AmountsLengthMustEqualOneError = AmountsLengthMustEqualOneError;
var TooFewBrokerAssetsProvidedError = /** @class */ (function (_super) {
    __extends(TooFewBrokerAssetsProvidedError, _super);
    function TooFewBrokerAssetsProvidedError(numBrokeredAssets) {
        return _super.call(this, 'TooFewBrokerAssetsProvidedError', 'TooFewBrokerAssetsProvidedError(uint256 numBrokeredAssets)', {
            numBrokeredAssets: numBrokeredAssets,
        }) || this;
    }
    return TooFewBrokerAssetsProvidedError;
}(revert_error_1.RevertError));
exports.TooFewBrokerAssetsProvidedError = TooFewBrokerAssetsProvidedError;
var InvalidFunctionSelectorError = /** @class */ (function (_super) {
    __extends(InvalidFunctionSelectorError, _super);
    function InvalidFunctionSelectorError(selector) {
        return _super.call(this, 'InvalidFunctionSelectorError', 'InvalidFunctionSelectorError(bytes4 selector)', { selector: selector }) || this;
    }
    return InvalidFunctionSelectorError;
}(revert_error_1.RevertError));
exports.InvalidFunctionSelectorError = InvalidFunctionSelectorError;
var OnlyERC1155ProxyError = /** @class */ (function (_super) {
    __extends(OnlyERC1155ProxyError, _super);
    function OnlyERC1155ProxyError(sender) {
        return _super.call(this, 'OnlyERC1155ProxyError', 'OnlyERC1155ProxyError(address sender)', { sender: sender }) || this;
    }
    return OnlyERC1155ProxyError;
}(revert_error_1.RevertError));
exports.OnlyERC1155ProxyError = OnlyERC1155ProxyError;
var types = [
    InvalidFromAddressError,
    AmountsLengthMustEqualOneError,
    TooFewBrokerAssetsProvidedError,
    InvalidFunctionSelectorError,
    OnlyERC1155ProxyError,
];
try {
    // Register the types we've defined.
    for (var types_1 = __values(types), types_1_1 = types_1.next(); !types_1_1.done; types_1_1 = types_1.next()) {
        var type = types_1_1.value;
        revert_error_1.RevertError.registerType(type);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (types_1_1 && !types_1_1.done && (_a = types_1.return)) _a.call(types_1);
    }
    finally { if (e_1) throw e_1.error; }
}
//# sourceMappingURL=revert_errors.js.map